import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, Grid, TextField, Stack, Typography } from "@mui/material";

import DebouncedAWSLocationInput from "../Common/DebouncedAWSLocationInput";


export default function Localisation3({ upperState, mode, upperSendLoc }) {

	const [state, setState] = useState({ ...upperState, manual: false, has_loc: false });


	const handleChange = (event) => {
		setState({ ...state, [event.target.name]: event.target.value, changes: true });
	};
	const handleChangeLoc = (loc) => {

		if (loc === undefined) {

			setState({ ...state, loc: loc, has_loc: false, manual: false });
		} else {


			//var zp = loc.context.find((ln) => { return ln.id.startsWith("postcode.") }) !== undefined ? loc.context.find((ln) => { return ln.id.startsWith("postcode.") }).text_fr : "N/A"
			//var ct = loc.context.find((ln) => { return ln.id.startsWith("place.") }) !== undefined ? loc.context.find((ln) => { return ln.id.startsWith("place.") }).text_fr : "N/A"

			setState({ ...state, loc: loc, has_loc: true, addr_line1: (loc.AddressNumber ? loc.AddressNumber : "") + " " + loc.Street, addr_zip_code: loc.PostalCode, addr_city: loc.Municipality, manual: false });
		}
		if (mode === "ADR") {
			upperSendLoc(loc);
			return
		}
		if (mode === "AMB") {
			upperSendLoc(loc);
			return
		}
		if (mode === "USR") {
			upperSendLoc(
				{ target: { name: "loc", value: loc } })
			return
		}
		if (mode === "AMB2") {
			upperSendLoc(
				{ target: { name: "loc_amb", value: loc } })
			return
		}
		if (mode === "NTR") {
			upperSendLoc(
				{ target: { name: "loc_ntr", value: loc } })
			return
		}
		if (mode === "PRX") {
			upperSendLoc(
				{ target: { name: "loc", value: loc } })
			return
		}
	};

	const handleChangeState = (st) => {

		setState({ ...state, ...st });
	};

	useEffect(() => {
		if (state.manual) {
			if (state.addr_line1 !== undefined && state.addr_zip_code !== undefined && state.addr_city !== undefined) {
				console.log("bubble up");
				var adr_record = {
					Label: state.addr_line1 + ", " + state.addr_zip_code + " " + state.addr_city,
					Street: state.addr_line1, PostalCode: state.addr_zip_code, Municipality: state.addr_city, Country: "FRA"
				}
				var lloc = adr_record;

				if (mode === "USR") {
					lloc = {
						target: {
							name: "loc", value: adr_record
						}
					};
				}
				if (mode === "AMB2") {
					lloc = {
						target: {
							name: "loc_amb", value: adr_record
						}
					};
				}
				if (mode === "NTR") {
					lloc = {
						target: {
							name: "loc_ntr", value: adr_record
						}
					};
				}

				upperSendLoc(lloc)
			} else {
				var lloc = undefined;
				if (mode === "USR") {
					lloc = {
						target: {
							name: "loc", value: undefined
						}
					};
				}
				if (mode === "AMB2") {
					lloc = {
						target: {
							name: "loc_amb", value: undefined
						}
					};
				}
				if (mode === "NTR") {
					lloc = {
						target: {
							name: "loc_ntr", value: undefined
						}
					};
				}
				upperSendLoc(lloc);
			}
		}

	}, [state.addr_line1, state.addr_zip_code, state.addr_city]);
	return (
		<Box display={"flex"} justifyContent="flex-start" alignItems={"center"}>
			{!state.manual && <Box >
				<div style="margin-bottom: 10px;">
					<DebouncedAWSLocationInput resultsCallback={handleChangeLoc} setUpperState={handleChangeState} upperState={state} mode={mode} />
				</div>
				{state.loc && (
					<img
						src={`https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/pin-s+ea5140(${state.loc.Geometry.Point[0]},${state.loc.Geometry.Point[1]})/${state.loc.Geometry.Point[0]},${state.loc.Geometry.Point[1]},15,0/300x300?access_token=pk.eyJ1IjoidGVsZW1ldGlzIiwiYSI6ImNrcWZvd2c0MzByM2wybnNjOGR2c2JtNGEifQ.npIdy2KCcctfSjvVWcSDXw`}
					/>
				)}
			</Box>}
			<Box p={1}>
				<Stack alignItems={"center"} justifyContent={"space-between"} style={"height: 100%;"}>
					<Stack alignItems={"center"} justifyContent={"flex-start"} >

						{state.hit && !state.manual && <div>
							<Button
								onClick={() => {
									setState({ ...state, manual: true, has_loc: false });
								}}
							>
								Je ne trouve pas l'adresse&nbsp;?
							</Button>
						</div>}
						{state.manual && <div>
							<Button
								onClick={() => {
									setState({ ...state, manual: false, has_loc: false });
								}}
							>
								Annuler
							</Button>
						</div>}
						{!state.manual && state.has_loc && (
							<div>
								<Typography variant="h5">Adresse</Typography>
								<Typography variant="body1">{state.addr_line1}</Typography>
								<Typography variant="body1">{state.addr_zip_code} {state.addr_city}</Typography>
							</div>
						)}
						{state.manual && (
							<div>
								<div>
									<TextField
										id="addr_line1"
										name="addr_line1"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Adresse"
										fullWidth
										margin="dense"
										size="small"
										value={state.addr_line1}
										onChange={handleChange}
										disabled={!state.manual}
									/>
								</div>

								<div>
									<Box display="flex" alignItems="center" justifyContent="flex-end" p={1} m={1} style="padding: 0px; margin: 0px;">
										<Box p={1} style="padding: 0px; margin: 0px;">
											<TextField
												id="addr_zip_code"
												name="addr_zip_code"
												variant="outlined"
												style={{
													marginLeft: 0,
													marginRight: 10,
												}}
												placeholder="Code postal *"
												margin="dense"
												size="small"
												value={state.addr_zip_code}
												onChange={handleChange}
												disabled={!state.manual}
											/>
										</Box>
										<Box p={1} style="padding: 0px; margin: 0px; width: 100%">
											<TextField
												id="addr_city"
												name="addr_city"
												variant="outlined"
												style={{
													marginLeft: 0,
													marginRight: 10,
													width: "100%",
												}}
												placeholder="Ville *"
												margin="dense"
												size="small"
												value={state.addr_city}
												onChange={handleChange}
												disabled={!state.manual}
											/>
										</Box>
									</Box>
								</div>
							</div>
						)}
					</Stack>

				</Stack>


			</Box>
		</Box>

	);
}
